type PresenceStatus = 'online' | 'in_game' | 'offline';

const STYLE: Record<PresenceStatus, { color: string; glow: string }> = {
  online:  { color: '#4ADE80', glow: '0 0 5px 1px rgba(74,222,128,0.6)'   },
  in_game: { color: '#A855F7', glow: '0 0 5px 1px rgba(168,85,247,0.6)'  },
  offline: { color: '#444444', glow: 'none'                                },
};

interface Props {
  status: PresenceStatus;
  /** Diameter in px. Default 10. */
  size?:   number;
  /** Optional CSS border string — use for avatar-badge overlap cutout. */
  border?: string;
  style?:  React.CSSProperties;
}

/** Presence indicator light. Glows for online/in_game, dim for offline. */
export function PresenceDot({ status, size = 10, border, style }: Props) {
  const { color, glow } = STYLE[status];
  return (
    <span
      style={{
        display:         'inline-block',
        flexShrink:      0,
        width:           size,
        height:          size,
        borderRadius:    '50%',
        backgroundColor: color,
        boxShadow:       glow,
        border,
        ...style,
      }}
    />
  );
}
